module.exports = __webpack_public_path__ + "img/credit-card-front.4251b7ef.svg";